module.exports = __webpack_public_path__ + "img/casantino-py.8ee201d8.jpg";